import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { reduxForm } from 'redux-form';
import idx from 'idx';
import isEmail from 'sane-email-validation';
import partial from 'lodash/partial';
import { EMAIL_INVALID_MESSAGE } from 'common/components/form_fields';
import { fetchGroup } from 'focus_groups/ducks/view_state';
import { setParticipantInfo, toggleConfirmVote, setStage } from 'focus_groups/ducks/vote';
import ParticipantInfoForm from 'focus_groups/components/participant_info_form';

const mapStateToProps = (state) => {
  const group = idx(state, _ => _.project.focusGroups.viewState.currentGroup);
  const email = idx(group, _ => _.participant.email) || '';

  return {
    client: idx(group, _ => _.project.client),
    shareResults: idx(group, _ => _.share_results),
    initialValues: {
      email: email.endsWith('@noemailprovided.com') ? '' : email,
      accepted_promo: true
    }
  };
}

const mapDispatchToProps = (dispatch, { params }) => {
  const { focusGroupId, participantId, participantKey } = params;

  return bindActionCreators({
    setParticipantInfo: partial(setParticipantInfo, focusGroupId, participantId, participantKey),
    fetchGroup: partial(fetchGroup, focusGroupId, participantKey),
    toggleConfirmVote,
    setStage
  }, dispatch);
}

const validate = (values, { submittingVotes }) => {
  const errors = {};

  /* only require email if not submitting votes */
  if ((!submittingVotes || values.email) && !isEmail(values.email)) {
    errors.email = EMAIL_INVALID_MESSAGE;
  }
  return errors;
}

const wrappedForm = reduxForm({
  form: 'ParticipantInfoForm',
  destroyOnUnmount: false,
  validate
})(ParticipantInfoForm);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(wrappedForm));



// WEBPACK FOOTER //
// ./focus_groups/containers/participant_info_form.js